import { useState } from "react";
import { toast } from "@/components/Toast";
import { C } from "@/lib/brand";

// One-click clipboard button used across the affiliate content sections
// (hooks, sample posts, disclaimers, FAQs). Falls back to a long-press
// selection hint on browsers/contexts where `navigator.clipboard` is
// blocked (some iOS PWAs, no-https contexts).
//
// Behaviour:
//   - clicking copies `text` and flashes a brief "COPIED ✓" state for 1.2s
//   - disabled state when text is empty
//   - small (default) and inline visual variants
export default function CopyButton({ text, label = "COPY", testId, variant = "solid" }) {
  const [copied, setCopied] = useState(false);
  const handle = async () => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      toast("Couldn't auto-copy. Long-press the text to select and copy.", "info");
    }
  };
  const solid = variant === "solid";
  return (
    <button
      type="button"
      onClick={handle}
      disabled={!text}
      data-testid={testId}
      style={{
        padding: solid ? "9px 14px" : "6px 10px",
        background: copied ? C.sageDeep : solid ? C.ink : "transparent",
        color: copied ? C.cream : solid ? C.cream : C.ink,
        border: solid ? 0 : `1px solid ${C.ink}`,
        fontSize: 10,
        fontWeight: 800,
        letterSpacing: "0.2em",
        cursor: text ? "pointer" : "not-allowed",
        opacity: text ? 1 : 0.4,
        transition: "background 120ms, color 120ms",
        whiteSpace: "nowrap",
      }}
    >
      {copied ? "COPIED ✓" : label}
    </button>
  );
}
